import { SourceTypeResponse } from "api/company";
import { useHistory } from "react-router-dom";
import { formatUrl, getSourceTypeLinkUrl } from "utils";

import { CompanyParams, routes } from "config/urls";

import useFilteredQueryString from "./useFilteredQueryString";

const useNextSourceTypeRedirectHandler = (
  companyId: string,
  sourceType?: SourceTypeResponse,
  isSkipToOverview?: boolean
): (() => void) | undefined => {
  const history = useHistory();
  const search = useFilteredQueryString();

  if (isSkipToOverview) {
    return () =>
      history.push({
        pathname: formatUrl<CompanyParams>(routes.company.overview, {
          companyId,
        }),
        search,
      });
  }

  if (!sourceType) {
    return;
  }

  return () =>
    history.push({
      pathname: getSourceTypeLinkUrl(companyId, sourceType),
      search,
    });
};

export default useNextSourceTypeRedirectHandler;
